<si-application-header class="top-navigation-header">
    <si-header-brand>
        <a siHeaderLogo routerLink="/" class="brand-link">
            @if (logoUrl()) {
                <img [src]="logoUrl()" class="logo" alt="Company logo" />
            }
        </a>
    </si-header-brand>

    <si-header-actions>
        @if (isEnergyTenant()) {
            <button
                type="button"
                class="si-header-item inline-flex items-center gap-1.5 rounded-full bg-status-warning/15 px-3 py-1.5 text-xs font-semibold text-status-warning transition hover:bg-status-warning/25 focus-visible:outline-2 focus-visible:outline-focus"
                (click)="openEnergyDialog()"
                [attr.aria-label]="'accessibility.energy-notice' | translate"
            >
                <si-icon icon="element-warning" class="text-sm" />
                <span class="hidden sm:inline">Energy Notice</span>
            </button>
        }

        @if (currentUser) {
            <button
                type="button"
                class="si-header-item btn btn-circle btn-ghost profile-trigger"
                [siHeaderDropdownTriggerFor]="profileDropdown"
                [attr.aria-label]="
                    'accessibility.open-profile'
                        | translate: { name: currentUser.firstname + ' ' + currentUser.surname }
                "
            >
                <si-avatar
                    [initials]="userInitials"
                    [altText]="currentUser.firstname + ' ' + currentUser.surname"
                    [imageUrl]="userPhotoUrl()"
                />
            </button>
            <div class="user-data hide-mobile">
                <div class="user-name">
                    {{ currentUser.surname | uppercase }}, {{ currentUser.firstname | uppercase }}
                </div>
                <div class="user-department">{{ currentUser.department }}</div>
            </div>
            <ng-template #profileDropdown>
                <si-header-dropdown>
                    <div class="dropdown-panel user-dropdown" (click)="$event.stopPropagation()">
                        <div class="profile-header">
                            <si-avatar
                                [initials]="userInitials"
                                [altText]="currentUser.firstname + ' ' + currentUser.surname"
                                [imageUrl]="userPhotoUrl()"
                                class="profile-avatar"
                            />
                            <div class="profile-details">
                                <div class="profile-name">{{ currentUser.firstname }} {{ currentUser.surname }}</div>
                                <div class="profile-department">{{ currentUser.department }}</div>
                                <div class="profile-email">{{ currentUser.email }}</div>
                            </div>
                        </div>
                    </div>
                </si-header-dropdown>
            </ng-template>
        }

        <div class="header-divider hide-mobile"></div>
        <!--
        TODO: The theme toggle is currently disabled as the frontend is optimized for light mode. After customer
        agreement, we can enable the dark mode toggle and implement the necessary styling adjustments for dark mode. -->
        <!-- <button
            type="button"
            class="si-header-item btn btn-circle btn-ghost header-action-btn"
            [attr.aria-label]="isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'"
            (click)="toggleTheme()"
        >
            <si-icon [icon]="themeIcon" />
        </button> -->

        <button
            type="button"
            class="si-header-item btn btn-circle btn-ghost header-action-btn"
            [siHeaderDropdownTriggerFor]="settingsDropdown"
            [attr.aria-label]="'accessibility.open-language-selection' | translate"
        >
            <si-icon icon="element-global" />
        </button>
        <ng-template #settingsDropdown>
            <si-header-dropdown>
                <div class="dropdown-panel settings-dropdown" (click)="$event.stopPropagation()">
                    <div class="dropdown-title">{{ 'LanguageSettings' | translate }}</div>
                    @for (item of languages; track item) {
                        <button
                            type="button"
                            class="dropdown-item"
                            [attr.aria-label]="'accessibility.select-language' | translate: { language: item.title }"
                            (click)="changeLanguage(item.codeName)"
                        >
                            <span>{{ item.title }}</span>
                            @if (currentlang === item.codeName) {
                                <span class="selected-mark">●</span>
                            }
                        </button>
                    }
                </div>
            </si-header-dropdown>
        </ng-template>

        <button
            type="button"
            class="si-header-item btn btn-circle btn-ghost header-action-btn"
            [siHeaderDropdownTriggerFor]="helpDropdown"
            [attr.aria-label]="'accessibility.open-help' | translate"
        >
            <si-icon icon="element-help" />
        </button>
        <ng-template #helpDropdown>
            <si-header-dropdown>
                <div class="dropdown-panel help-dropdown" (click)="$event.stopPropagation()">
                    @for (item of helpMenuLinks; track item) {
                        <a
                            class="dropdown-link"
                            target="_blank"
                            rel="noopener noreferrer"
                            [href]="item.url | translate"
                        >
                            <si-icon icon="element-link" />
                            <span>{{ item.trasnlationString | translate }}</span>
                        </a>
                    }

                    <hr class="dropdown-separator" />

                    @for (item of infoFiles(); track item) {
                        <button
                            type="button"
                            class="dropdown-item"
                            [attr.aria-label]="
                                'accessibility.open-document' | translate: { document: item.title | translate }
                            "
                            (click)="getFile(item)"
                        >
                            <si-icon icon="element-link" />
                            <span>{{ item.title | translate }}</span>
                        </button>
                    }

                    <hr class="dropdown-separator" />

                    <button
                        type="button"
                        class="dropdown-item"
                        [attr.aria-label]="'accessibility.data-modification-unavailable' | translate"
                        disabled
                    >
                        <si-icon icon="element-link" />
                        <span>{{ 'app.datamodification' | translate }}</span>
                    </button>
                </div>
            </si-header-dropdown>
        </ng-template>

        <div class="sal-logo hide-mobile mr-2">
            @if (salLogoUrl()) {
                <img [src]="salLogoUrl()" alt="SAL logo" />
            }
        </div>
    </si-header-actions>
</si-application-header>
